import calmelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import { parseQueryParams } from '@lwtears/lwt-common-frontend/lib/@common/util/query-params-util';
import { createLog } from '../api';
import { Sources, TelemetryEventTypes, TelemetryLogTypes } from '../types';

export const sendEventAccessLink = (link: string | undefined, route: Sources) => {
  createLog(TelemetryEventTypes.ACCESS_LINK, {
    link,
    route,
  });
};

export const sendGraphErrorLog = (data) => {
  createLog(TelemetryLogTypes.GRAPH_ERROR, data);
};

export const formatErrors = (graphQLErrors, networkError) => {
  const errorObj = graphQLErrors[0]
    ? { ...graphQLErrors[0] }
    : {
        ...networkError,
        ...(networkError?.result?.errors?.[0] ?? {}),
      };

  if (errorObj?.extensions?.exception?.locations) delete errorObj?.extensions?.exception?.locations;
  if (errorObj?.result?.errors) delete errorObj.result.errors;
  delete errorObj?.locations;
  return errorObj;
};

export const sendEventLoginSuccess = async (signature: string, params?) => {
  const mapKeysToCamelCase = (obj) => mapKeys(obj, (_, key) => calmelCase(key));

  const searchParams = parseQueryParams(window.location.search);
  const hasCampaignParams = Object.keys(searchParams ?? {}).some((x) => x.includes('utm_'));
  const maybeCampaignParams = hasCampaignParams && { campaign: mapKeysToCamelCase(searchParams) };

  return createLog(TelemetryEventTypes.LOGIN_SUCCESS, {
    authenticationSource: 'lwt',
    sessionId: signature,
    ...maybeCampaignParams,
    ...params,
  });
};
